import React from 'react';
import { PrintProvider } from '@contexts/PrintContext.tsx';
import { ConfigDto, SampleDetailsDto, SampleStatus } from '@src/types/types';
import { SampleHeader } from './SampleHeader';
import { UserInfo } from './UserInfo';
import { ShipmentStatus } from '../organisms/ShipmentStatus';
import { SampleInstructions } from './SampleInstructions';
import { DividerLine } from '../atoms/DividerLine';
import { SampleDonePdf } from './SampleDonePdf';

interface SampleDetailsProps {
  sample: SampleDetailsDto;
  config: ConfigDto;
}

export const SampleDetails: React.FC<SampleDetailsProps> = ({
  sample,
  config,
}) => {
  return (
    <div className="flex flex-col space-y-8">
      <SampleHeader sample={sample} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <UserInfo sample={sample} />
        <ShipmentStatus sample={sample} />
      </div>

      <DividerLine />

      {sample.status === SampleStatus.DONE ? (
        <PrintProvider>
          <SampleDonePdf sample={sample} config={config} />
        </PrintProvider>
      ) : (
        <SampleInstructions sample={sample} config={config} />
      )}
    </div>
  );
};
